import { APP_ROUTES, PROFILE_ROUTE_SEGMENTS } from '@routes/routes.constants';

import type { NavigationItem } from './NavigationItems.types';

export const navigationItems: NavigationItem[] = [
  {
    heapId: 'personal-information',
    label: 'Personal information',
    path: `${APP_ROUTES.PROFILE}/${PROFILE_ROUTE_SEGMENTS.PERSONAL_INFORMATION}`,
    requiredPermissions: [
      'ProfilePersonalBasic_FullAccess_Own',
      'ProfilePersonalTraining_FullAccess_Own',
    ],
    operator: 'some',
  },
  {
    heapId: 'notifications',
    label: 'Notifications',
    path: `${APP_ROUTES.PROFILE}/${PROFILE_ROUTE_SEGMENTS.NOTIFICATIONS}`,
    requiredPermissions: [
      'ProfileNotifications_FullAccess_Own',
    ],
    operator: 'some',
  },
  {
    heapId: 'password-and-security',
    label: 'Password and security',
    path: `${APP_ROUTES.PROFILE}/${PROFILE_ROUTE_SEGMENTS.PASSWORD_AND_SECURITY}`,
    requiredPermissions: ['ProfilePassword_FullAccess_Own'],
  },
];
